import React, { useState } from 'react'
import { StaticQuery, graphql } from 'gatsby'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import styled, { ThemeProvider } from 'styled-components'
import { ThemeProvider as MuiThemeProvider } from '@material-ui/styles'
import { createMuiTheme } from '@material-ui/core/styles'
import { CssBaseline, Fab } from '@material-ui/core'
import { ColorLens } from '@material-ui/icons'
import { ContextProviderComponent } from './Context'
import BrowserView from '../utils/BrowserView'
import MobileView from '../utils/MobileView'
import Header from './Header'
import Betslip from './Betslip/Betslip'
import MobileBetslip from './Betslip/MobileBetslip'
import BottomNavBar from './BottomNavBar'
import AccountMenu from './AccountMenu'
import ScrollAllowance from './ScrollAllowance'
import { geniusTheme } from '../utils/theme'
import ThemeEditorDrawer from './ThemeEditor/ThemeEditorDrawer'

const FauxToolbar = styled.div`
  ${props => props.theme.mixins.toolbar};
`

const EditThemeButton = styled(Fab)`
  position: fixed;
  bottom: ${props => props.theme.spacing(4)}px;
  right: ${props => props.theme.spacing(4)}px;
`

const Layout = ({ children, pageContext }) => {
  const [theme, setTheme] = useState({
    ...geniusTheme,
    name: 'light',
    file: '',
    imagePreviewUrl: '',
    imageWidth: '',
    imageHeight: '',
  })

  const currentTheme = createMuiTheme(theme)

  const [themeEditorOpen, setThemeEditorOpen] = useState(false)

  const handleThemeEditorClose = () => setThemeEditorOpen(false)

  return (
    <StaticQuery
      query={graphql`
        query SiteTitleQuery {
          site {
            siteMetadata {
              title
            }
          }
        }
      `}
      render={data => (
        <>
          <MuiThemeProvider theme={currentTheme}>
            <CssBaseline />
            <ThemeProvider theme={currentTheme}>
              <ContextProviderComponent>
                <Helmet>
                  <title>{data.site.siteMetadata.title}</title>
                  <meta
                    name="viewport"
                    content="minimum-scale=1, initial-scale=1, width=device-width, shrink-to-fit=no"
                  />
                  <link
                    href="https://fonts.googleapis.com/css?family=Lato:400,700&display=swap"
                    rel="stylesheet"
                  />
                  <link
                    href="https://fonts.googleapis.com/css?family=Work+Sans:800,900&display=swap"
                    rel="stylesheet"
                  />
                  <html lang="en" />
                </Helmet>
                {pageContext.header !== 'hidden' && (
                  <>
                    <Header
                      siteTitle={data.site.siteMetadata.title}
                      theme={currentTheme}
                    />
                    <FauxToolbar />
                  </>
                )}
                <BrowserView>{children}</BrowserView>
                <MobileView>
                  {pageContext.header !== 'hidden' ? (
                    <ScrollAllowance>{children}</ScrollAllowance>
                  ) : (
                    <>{children}</>
                  )}
                </MobileView>
                {pageContext.header !== 'hidden' && (
                  <MobileView>
                    <BottomNavBar />
                  </MobileView>
                )}
                {pageContext.betslip !== 'hidden' && (
                  <>
                    <BrowserView>
                      <Betslip pageContext={pageContext} position="fixed" />
                    </BrowserView>
                    <MobileView>
                      <MobileBetslip />
                    </MobileView>
                  </>
                )}
                <AccountMenu />
                <BrowserView>
                  <EditThemeButton
                    color="secondary"
                    aria-label="edit"
                    onClick={() => setThemeEditorOpen(true)}
                  >
                    <ColorLens />
                  </EditThemeButton>
                  <ThemeEditorDrawer
                    open={themeEditorOpen}
                    handleClose={handleThemeEditorClose}
                    theme={theme}
                    setTheme={setTheme}
                  />
                </BrowserView>
                {pageContext.layout === 'themeEditor' && (
                  <MobileView>
                    <EditThemeButton
                      color="secondary"
                      aria-label="edit"
                      onClick={() => setThemeEditorOpen(true)}
                    >
                      <ColorLens />
                    </EditThemeButton>
                    <ThemeEditorDrawer
                      open={themeEditorOpen}
                      handleClose={handleThemeEditorClose}
                      theme={theme}
                      setTheme={setTheme}
                    />
                  </MobileView>
                )}
              </ContextProviderComponent>
            </ThemeProvider>
          </MuiThemeProvider>
        </>
      )}
    />
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  pageContext: PropTypes.object.isRequired,
}

export default Layout
